import { ApiResponse } from "../../../../Data/apiResponse";
import axios from 'axios';

export const getData = async (apiEndpoint: string) => {
    const response: ApiResponse<any> = await axios.get(apiEndpoint);
    return response;
}
